import ReducerUtilities from '../../../shared/store/reducer-utilities';
import reportModel from '../../models/report';
import reportsCommitTypes from './commit-types';

const INITIAL_REPORTS_STATE = {
  isAddingReport: false,
  isEditingReport: null,
  viewingReport: null,
  isLoading: [],
  list: null,
  openReportList: null
};

function reportsReducers(state = INITIAL_REPORTS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case reportsCommitTypes.PUSH_REPORT:
      return {
        ...state,
        list: [...state.list, reportModel(action.report)],
      };
    case reportsCommitTypes.PUSH_REPORTS:
      return {
        ...state,
        list: [...action.list.map(item => reportModel(item))],
      };
    case reportsCommitTypes.PUSH_OPEN_REPORTS:
      console.log('PUSH_OPEN_REPORTS', action)
      return {
        ...state,
        openReportList: [...action.list.map(item => reportModel(item))],
      };
    case reportsCommitTypes.PUSH_REPORTS_FOR_APPROVE:
      return {
        ...state,
        list: [...(state.list || []), ...action.list.map(item => reportModel(item))],
      };
    case reportsCommitTypes.REPLACE_REPORT:
      return {
        ...state,
        list: state.list? [
          ...ReducerUtilities.replaceModelInList(
            reportModel(action.report),
            state.list,
          ),
        ]: state.list,
        openReportList: state.openReportList? [
          ...ReducerUtilities.replaceModelInList(
            reportModel(action.report),
            state.openReportList,
          ),
        ]: state.openReportList
      };
    case reportsCommitTypes.UPDATE_SIGN_ACTORS:
      return {
        ...state,
        list: state.list? state.list.map(r => {
          if(r.guid === action.guid) {
           return {
             ...r,
             signActors: action.signActors,
             trainingPhaseSignActor: action.signActors,
           }
          }
          return r
        }): state.list,
        openReportList: state.openReportList? state.openReportList.map(r => {
          if(r.guid === action.guid) {
            return {
              ...r,
              signActors: action.signActors,
              trainingPhaseSignActor: action.signActors,
            }
          }
          return r
        }): state.openReportList
      };
    case reportsCommitTypes.RESET_REPORTS_STATE:
      return { ...INITIAL_REPORTS_STATE };
    case reportsCommitTypes.SET_IS_ADDING_REPORT:
      return {
        ...state,
        isAddingReport: action.isAddingReport,
      };
    case reportsCommitTypes.SET_IS_EDITING_REPORT:
      return {
        ...state,
        isEditingReport: action.isEditingReport,
      };
    case reportsCommitTypes.SET_IS_VIEWING_REPORT:
      return {
        ...state,
        viewingReport: action.viewingReport,
      };
    case reportsCommitTypes.SET_REPORTS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    case reportsCommitTypes.REMOVE_REPORT:
      return {
        ...state,
        list: [
          ...ReducerUtilities.removeModelFromList(
            action.reportGuid,
            state.list,
          ),
        ],
        openReportList: [
          ...ReducerUtilities.removeModelFromList(
            action.reportGuid,
            state.openReportList,
          ),
        ],
      };
    default:
      return state;
  }
}

export default reportsReducers;
